/* src/app/private/components/manage-campaign/test-call/test-call.component.scss */
.invalid-phone-text {
  color: red;
  font-weight: 500;
  font-size: 11px;
  margin-top: 6px;
  margin-left: 5px;
}
/*# sourceMappingURL=test-call.component.css.map */
